<template>
  <vs-col
      class="p-0"
      vs-align="center"
      vs-justify="flex-end"
      vs-type="flex"
      vs-w="2.8"
  >
    <SideBar
        :active="modalServicosAgenda"
        :title="'Editar Agenda: ' + endereco.nome"
        :visualizar="!buttonStatus"
        size="huger"
        textSucces="Salvar"
        @hide="modalServicosAgenda = false"
        @success="submitForm()"
    >
      <div
          id="editarAgenda"
          slot="body"
          class="w-full p-4 vs-con-loading__container"
      >
        <vs-col vs-w="5">
          <div class="w-full">
            <vs-col vs-type="flex" vs-w="12">
              <Agenda class="m-4"></Agenda>
            </vs-col>
          </div>
        </vs-col>
        <vs-col vs-w="7">
          <vs-divider border-style="dotted">Data dos serviços</vs-divider>
          <div id="head_modal_agenda" class="vs-con-loading__container">
            <VuePerfectScrollbar
                :settings="settings"
                class="scroll-servicos-editar-agenda"
            >
              <div v-for="(servico, index) in servicos" :key="index">
                <vs-row
                    vs-align="center"
                    vs-justify="flex-start"
                    vs-type="flex"
                    vs-w="10"
                >
                  <vs-col vs-type="flex" vs-w="3">
                    <div class="w-full mx-1">
                      <vs-input
                          v-model="servicos[index].data_servico"
                          :label="`OS N°${servico.id}`"
                          color="dark"
                          disabled
                          style="width: 140px"
                          type="date"
                      />
                    </div>
                  </vs-col>
                  <vs-col
                      vs-type="flex"
                      vs-w="3"
                  >
                    <div v-if="servico.executado < 1" class="w-full mx-1">
                      <vs-input
                          :key="key"
                          v-model="servicos[index].data_remarcacao_servico"
                          v-validate="'required'"
                          :name="'os' + index"
                          color="dark"
                          label="Data Remarcação"
                          style="width: 140px"
                          type="date"
                          @change="key++"
                      />
                    </div>
                    <label v-else class="font-bold" size="small"
                    >OS com retorno!</label
                    >
                  </vs-col>
                  <vs-col v-if="servico.executado < 1" vs-type="flex" vs-w="3">
                    <div class="w-full mx-1">
                      <div style="display: flex !important; align-items: center; justify-content: space-between; width: 140px;">
                        <label style="color: black; font-size: 0.85rem;">
                          {{ servicos[index].agendarPorTurno ? 'Turno' : 'Hora Marcada' }}
                        </label>
                        <vs-switch v-model="servicos[index].agendarPorTurno" @input="toggleAgendamento(index)">
                          <span slot="on"></span>
                          <span slot="off"></span>
                        </vs-switch>
                      </div>
                      <div v-if="servicos[index].agendarPorTurno">
                        <el-select
                            v-model="servicos[index].id_turno"
                            v-validate="'required'"
                            :name="'turno' + index"
                            :popper-append-to-body="false"
                            clearable
                            filterable
                            placeholder="Selecione..."
                            style="width: 140px"
                        >
                          <el-option
                              v-for="turno in turnos"
                              :key="turno.id"
                              :label="turno.nome"
                              :value="turno.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div v-else>
                        <vs-input
                            v-model="servicos[index].hora_marcada"
                            v-mask="'##:00'"
                            v-validate="'required'"
                            :name="'horario' + index"
                            class="inputx"
                            max="24"
                            placeholder="00:00"
                            style="width: 140px"
                            type="datetime"
                        />
                      </div>
                    </div>
                  </vs-col>
                  <vs-col v-if="servico.executado < 1" vs-type="flex" vs-w="3">
                    <div class="w-full mx-1">
                      <label style="color: black; font-size: 0.85rem"
                      >Prioridade</label
                      >
                      <br/>
                      <el-select
                          v-model="servicos[index].id_nivel_prioridade"
                          v-validate="false"
                          :name="'prioridade' + index"
                          :popper-append-to-body="false"
                          clearable
                          filterable
                          placeholder="Selecione..."
                          style="width: 140px"
                      >
                        <el-option
                            v-for="nivel in nivel_prioridade"
                            :key="nivel.id"
                            :label="nivel.nome"
                            :value="nivel.id"
                        ></el-option>
                      </el-select>
                    </div>
                  </vs-col>
                </vs-row>
              </div>
            </VuePerfectScrollbar>
          </div>
          <div class="w-full mt-3">
            <vs-row
                vs-align="center"
                vs-justify="start"
                vs-type="flex"
                vs-w="12"
            >
              <vs-col vs-type="flex" vs-w="10">
                <div class="w-full mx-2">
                  <vs-textarea
                      v-model="obsRemarcacao"
                      v-validate="'required'"
                      class="w-full"
                      color="dark"
                      label="Motivo da alteração"
                      name="obs"
                  />
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </div>
    </SideBar>
  </vs-col>
</template>
<script>
import components from "@/components/default/exports.js";
import Agenda from "../../../agenda/Agenda.vue";

export default {
  props: {
    cliente: {require: true},
    contrato: {require: true},
    endereco: {nome: "Carregando", servicos: 0},
    servicoEndereco: null,
  },
  data() {
    return {
      key: 0,
      buttonStatus: true,
      modalServicosAgenda: false,
      turnos: [
        {id: 1, nome: "Manha"},
        {id: 2, nome: "Almoco"},
        {id: 3, nome: "Tarde"},
        {id: 4, nome: "Noite"},
        {id: 5, nome: "Madrugada"},
      ],
      nivel_prioridade: [
        {id: 1, nome: "Baixa"},
        {id: 2, nome: "Média"},
        {id: 3, nome: "Alta"}
      ],
      servicos: [],
      settings: {
        maxScrollbarLength: 200,
        wheelSpeed: 0.6,
        height: 1000,
      },
      obsRemarcacao: "",
    };
  },
  methods: {
    toggleAgendamento(index) {
      // Valor é limpo apenas no envio
    },
    async submitForm() {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.reagendarServicos();
            console.log(this.servicos);
          } else {
            this.$vs.notify({
              title: "Preencha todos os campos",
              text: "Os campos não devem ser vazios!",
              color: "danger",
            });
          }
        });
      });
    },
    async reagendarServicos() {
      await this.$vs.loading({
        container: "#editarAgenda",
        scale: 0.6,
      });
      
      let servicosParaEnviar = JSON.parse(JSON.stringify(this.servicos));
      for (let x of servicosParaEnviar) {
        if (x.agendarPorTurno) x.hora_marcada = null;
        else x.id_turno = null;
      }
      
      try {
        await this.$http.post("editarAgenda", {
          servicos: servicosParaEnviar,
          contrato: this.contrato,
          endereco: this.endereco,
          obs: this.obsRemarcacao,
        });
        await this.$emit("update");
        this.modalServicosAgenda = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close("#editarAgenda > .con-vs-loading");
      }
    },
    async getServicosEndereco() {
      await this.$vs.loading({
        container: "#editarAgenda",
        scale: 0.6,
      });
      try {
        const res = await this.$http.post("getServicosEndereco", {
          id_endereco: this.endereco.id_endereco,
          id_contrato: this.contrato.id,
        });
        this.servicos = res.servicos;

        for (let x of this.servicos) {
          x.data_remarcacao_servico = x.data_servico;
          if (x.id_turno) {
            x.id_turno = Number(x.id_turno);
          }
          
          const hasHora = x.hora_marcada && x.hora_marcada !== '00:00:00' && x.hora_marcada !== '00:00';
          
          if (hasHora) {
            this.$set(x, 'agendarPorTurno', false);
          } else {
            this.$set(x, 'agendarPorTurno', true);
          }
        }

        this.key++;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close("#editarAgenda > .con-vs-loading");
      }
    },
  },
  async mounted() {
    this.modalServicosAgenda = true;
    await this.getServicosEndereco();
  },
  components: {...components, Agenda},
};
</script>
<style lang="scss">
.scroll-servicos-editar-agenda {
  max-height: 50vh !important;
}
</style>
